// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__ygvSt","title":"ClientReferral_title__f-a2S","itemText":"ClientReferral_itemText__4pvtb"};